import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../context/UserContext';
import { api } from '../utils/apiHelper';
import '../styles/MemItems.css';

const MemItems = () => {
  const { authUser } = useContext(UserContext);
  const [memItems, setMemItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadMemItems = async () => {
    try {
      const res = await api('/get-mem-items', 'GET');
      if (res?.success) setMemItems(res.memItems);
    } catch (e) {
      console.error('Load memItems error:', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadMemItems(); }, []);

  const approve = async (item) => {
    try {
      const res = await api('/approve-mem-item', 'POST', {
        userId: item.userId,
        memItemId: item._id,
      });
      if (res.success) {
        // reflect approved status locally and who approved
        setMemItems(prev =>
          prev.map(m =>
            m._id === item._id && m.userId === item.userId
              ? { ...m, status: 'approved', approvedBy: authUser?.email || 'admin' }
              : m
          )
        );
      } else {
        alert('Failed to approve');
      }
    } catch (e) {
      console.error('Approve error:', e);
    }
  };

  const deny = async (item) => {
    const confirmed = window.confirm('Deny this item?');
    if (!confirmed) return;
    try {
      const res = await api('/deny-mem-item', 'POST', {
        userId: item.userId,
        memItemId: item._id,
      });
      if (res.success) {
        setMemItems(prev =>
          prev.map(m =>
            m._id === item._id && m.userId === item.userId
              ? { ...m, status: 'denied' }
              : m
          )
        );
      } else {
        alert('Failed to deny');
      }
    } catch (e) {
      console.error('Deny error:', e);
    }
  };

  if (authUser?.email !== 'support@editfarmer.com') return null;
  if (loading) return <p>Loading pending items…</p>;

  return (
    <div className="mem-items">
      <h3>Pending Member Items</h3>
      {memItems.length === 0 ? (
        <p>No pending items.</p>
      ) : (
        memItems.map((it) => (
          <div key={`${it.userId}-${it._id}`} className="mem-card">
            <h4>{it.title} <small>({it.shortCode})</small></h4>
            <p>{it.description}</p>
            <p><strong>Offer:</strong> ${it.price}</p>

            {it.status === 'approved' && (
              <span className="chip chip-approved">
                Approved {it.approvedBy ? `• ${it.approvedBy}` : ''}
              </span>
            )}

            {it.status === 'denied' && (
              <span className="chip chip-denied">Denied</span>
            )}

            {!it.status && (
              <div className="actions">
                <button className="approve-btn" onClick={() => approve(it)}>
                  Approve → Bid
                </button>
                <button onClick={() => deny(it)} className="secondary">
                  Deny
                </button>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default MemItems;
